import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import Radio from '../../atoms/Radio';
import { Container } from './radio-group.styles';

const RadioGroup = _ref => {
  let {
    options,
    selectedOption,
    onChange
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["options", "selectedOption", "onChange"]);

  return /*#__PURE__*/React.createElement(Container, null, options == null ? void 0 : options.map(option => {
    const {
      value,
      label,
      selected
    } = option;
    const checked = selected || value !== undefined && value === selectedOption || value === undefined && label === selectedOption;
    return /*#__PURE__*/React.createElement(Radio, _extends({
      key: value || label,
      value: value || label,
      label: label,
      checked: checked,
      onChange: e => onChange(e, option)
    }, props));
  }));
};

process.env.NODE_ENV !== "production" ? RadioGroup.propTypes = {
  name: string,
  options: arrayOf(shape({
    label: string.isRequired,
    value: oneOfType([string, number])
  })),
  selectedOption: oneOfType([string, number, bool]),
  onChange: func
} : void 0;
RadioGroup.defaultProps = {
  options: [],
  selectedOption: '',
  onChange: () => {}
};
export default RadioGroup;